import { BrowserRouter } from 'react-router-dom';
import { AuthGateScreen } from './components/app/AuthGate';
import { AuthenticatedAppShell } from './components/app/AuthenticatedAppShell';
import { DiscordHeatmapRender } from './components/app/DiscordHeatmapRender';
import { logoutOfWhopSession } from './lib/auth';
import { useAuthGate } from './hooks/useAuthGate';

function AuthenticatedApp() {
  const { authGateState, authRedirectError, revalidateAuth, retryAuth } = useAuthGate();
  const authData = authGateState.data;

  if (
    authGateState.status !== 'ready' ||
    authData == null ||
    !authData.authenticated ||
    !authData.hasAccess
  ) {
    return (
      <AuthGateScreen
        authGateState={authGateState}
        authRedirectError={authRedirectError}
        onRetry={retryAuth}
      />
    );
  }

  return (
    <AuthenticatedAppShell
      key={authData.user.whopUserId}
      userId={authData.user.whopUserId}
      userEmail={authData.user.email}
      accessLevel={authData.accessLevel}
      isAdmin={authData.isAdmin ?? false}
      onLogout={logoutOfWhopSession}
      onAuthRevalidationRequested={revalidateAuth}
    />
  );
}

function App() {
  const renderMatch =
    typeof window === 'undefined'
      ? null
      : window.location.pathname.match(/^\/internal\/discord-render\/([^/]+)$/);

  if (renderMatch != null) {
    return <DiscordHeatmapRender renderId={renderMatch[1]} />;
  }

  return (
    <BrowserRouter>
      <AuthenticatedApp />
    </BrowserRouter>
  );
}

export default App;
